<template>
  <div class="broken-unused">
    <broken-charger/>
    <unused-charger/>
  </div>
</template>

<script>

import BrokenCharger from "@/views/pages/status/brokenCharger.vue";
import UnusedCharger from "@/views/pages/status/unusedCharger.vue";

export default {
  name: "brokenUnused",
  components: { UnusedCharger, BrokenCharger },
  data() {
    return {}
  },
  methods: {}
}
</script>